import { Component } from '@angular/core';
import {DisclaimerService} from "../../services/disclaimer.service";
import {ConstantService} from "../../constants/constant.service";
import {MobileSizeService} from "../../services/mobile-size.service";

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.css']
})
export class DisclaimerComponent {
  constructor(public disclaimerService: DisclaimerService,
              public constantService: ConstantService,
              public mobileSizeService: MobileSizeService) {

  }

  onAccept() {
    this.disclaimerService.acceptTerms();
  }
}
